import axios from "axios";
import moment from "moment";
// import menuItems from "../data/menuItems.json";
import { IS_LAST_RECORD_DELETED } from "./constants";

export const capitalizeFirst = (str: string): string => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const getMenuRightsTypes = () => {
  return [
    { key: "isCreateRights", isChecked: false, title: "Create" },
    { key: "isViewRights", isChecked: false, title: "View" },
    { key: "isEditRights", isChecked: false, title: "Edit" },
    { key: "isDeleteRights", isChecked: false, title: "Delete" },
    { key: "isUserLevelRights", isChecked: false, title: "User Level" },
  ];
};

// export const getDefaultMenuList = () => {
//   return menuItems.map(({ id, title, submenu }) => ({
//     id: null,
//     moduleCode: Number(id),
//     title,
//     isChecked: false,
//     rightTypes: getMenuRightsTypes(),
//     submodules: (submenu ?? []).map(({ id, title }) => ({
//       id: null,
//       subModuleCode: Number(id),
//       title,
//       isCreateRights: false,
//       isViewRights: false,
//       isEditRights: false,
//       isDeleteRights: false,
//       isUserLevelRights: false,
//     })),
//   }));
// };

export const fnGetCurrentDate = () => {
  return moment.utc(moment(new Date()).format("YYYY-MM-DD")).toISOString();
};

export const resolveImageUrl = (url?: string) => {
  if (!url) {
    return "";
  }
  const trimmed = String(url).trim();
  if (!trimmed) return "";
  // Preserve data and blob URIs immediately
  if (trimmed.startsWith("data:") || trimmed.startsWith("blob:")) return trimmed;

  // Handle protocol-relative URLs (//example.com/path)
  if (trimmed.startsWith("//")) {
    // Prepend current page protocol (http: or https:)
    if (typeof window !== "undefined" && window.location && window.location.protocol) {
      return `${window.location.protocol}${trimmed}`;
    }
    return `https:${trimmed}`;
  }

  // If URL is absolute (http/https), return it — but upgrade to https when
  // the page is served over HTTPS to avoid mixed-content blocking.
  if (trimmed.startsWith("http://") || trimmed.startsWith("https://")) {
    if (typeof window !== "undefined" && window.location && window.location.protocol === "https:" && trimmed.startsWith("http://")) {
      try {
        const u = new URL(trimmed);
        u.protocol = "https:";
        return u.toString();
      } catch (e) {
        return trimmed.replace(/^http:\/\//i, "https://");
      }
    }
    return trimmed;
  }
  let base =
    ((axios.defaults?.baseURL as string) ||
      window.location.origin);
  base = String(base).replace(/\/$/, "");
  if (trimmed.startsWith("/")) return base + trimmed;
  return base + "/" + trimmed;
};

export const formatDateWithTime = (date: string | Date | number): string =>
  new Date(date).toLocaleDateString("en-GB", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

export const formatDateOnly = (date: string | Date | number): string =>
  new Date(date).toLocaleDateString("en-GB", {
    year: "numeric",
    month: "short",
    day: "2-digit",
  });

export const fnGetExactDate = (date: string | Date | number): string => {
  return new Date(date).toString();
};

export const __fnConvertUTCDate = (date: string | Date | number): Date => {
  let st = moment(date); // original date
  let stDate = st.toDate(); // convert moment to JS Date safely

  return new Date(
    Date.UTC(
      stDate.getFullYear(),
      stDate.getMonth(),
      stDate.getDate(),
      stDate.getHours(),
      stDate.getMinutes(),
      stDate.getSeconds(), // ✅ should be seconds, not milliseconds
      stDate.getMilliseconds()
    )
  );
};

export const __fnGetStartDate = (day?: number): Date => {
  let safeDays = day ?? 30;
  var future = new Date();
  future.setDate(future.getDate() - safeDays);
  return future;
};
export const __fnGetEndDate = () => {
  return new Date();
};
export const __fnGetCurrentDate = () => {
  return new Date();
};
export const __fnGetFormatedCurrentDate = () => {
  return fnGetExactDate(__fnGetCurrentDate());
};

export const fnSetLocalStorage = (key: string, data: object) => {
  if (key) {
    localStorage.setItem(key, data ? JSON.stringify(data) : "");
  }
};
export const fnGetLocalStorage = (key: string) => {
  let data = localStorage.getItem(key);
  return data ? JSON.parse(data) : null;
};

export const fnRemoveStorage = (key: string) => {
  localStorage.removeItem(key);
  fnRemoveLastRecord();
};

export const fnGetLocalStorageByKey = (key: string, property: string) => {
  if (key && property) {
    let data = fnGetLocalStorage(key);
    if (data != null) {
      return data[property] ? data[property] : null;
    }
  }
  return null;
};

export const fnSetIsLastRecord = (data: unknown[], filters: { pageNo: number }): void => {
  if (data && filters && data.length === 1 && filters.pageNo > 1) {
    localStorage.setItem(IS_LAST_RECORD_DELETED, true.toString());
    return;
  }
  fnRemoveLastRecord();
};
export const fnGetIsLastRecord = () => {
  return localStorage.getItem(IS_LAST_RECORD_DELETED) === "true";
};
export const fnRemoveLastRecord = () =>
  localStorage.removeItem(IS_LAST_RECORD_DELETED);

export const fnGetMaxOrderLimitNo = (): number => {
  const maxLimitEnv = process.env.REACT_APP_MAX_ORDER_QTY_LIMIT;
  return maxLimitEnv ? parseInt(maxLimitEnv, 10) : 10;
};

